import {
  BANNER_COMMON_EVENTS,
  TBannerDismiss,
  TBannerError,
  TBannerSelect,
  TBannerView,
} from '../tracking/index';
import { trackByEvent } from '../../tracking/services';
import { COMPONENT_TYPE } from '@src/tracking/constant';
import i18n, { defaultLang } from '@src/i18n';
import { useKeycloakUserState } from '../context/keycloak-user';
import { useTranslation } from 'react-i18next';
interface overrideParameters {
  banner_action_override?: string;
}
export default function (featureName: string, overrideComponentType = '') {
  const { restaurant } = useKeycloakUserState();
  const country = restaurant?.country || '';
  const language = i18n.language || defaultLang;
  const { t } = useTranslation();
  const trackBannerView = () => {
    try {
      const { component_type, event, banner_action } = BANNER_COMMON_EVENTS.BANNER_VIEW;
      const trackData: TBannerView = {
        component_name: featureName,
        component_type: (overrideComponentType || component_type) as COMPONENT_TYPE,
        banner_action,
        country,
        language,
        eventCategory: '',
      };
      trackByEvent<TBannerView>(event, trackData);
    } catch (error) {
      console.log('trackBannerView error', error);
    }
  };

  const trackBannerSelect = ({ banner_action_override }: overrideParameters = {}) => {
    try {
      const { component_type, event, banner_action } = BANNER_COMMON_EVENTS.BANNER_SELECT;
      const trackData: TBannerSelect = {
        component_name: featureName,
        component_type: component_type as COMPONENT_TYPE,
        banner_action: banner_action_override || banner_action,
        country,
        language,
        eventCategory: '',
      };
      trackByEvent<TBannerSelect>(event, trackData);
    } catch (error) {
      console.log('trackBannerSelect error', error);
    }
  };

  const trackBannerDismiss = () => {
    try {
      const { component_type, event, banner_action } = BANNER_COMMON_EVENTS.BANNER_DISMISS;
      const trackData: TBannerDismiss = {
        component_name: featureName,
        component_type: component_type as COMPONENT_TYPE,
        banner_action,
        country,
        language,
        eventCategory: '',
      };
      trackByEvent<TBannerDismiss>(event, trackData);
    } catch (error) {
      console.log('trackBannerDismiss error', error);
    }
  };

  const trackBannerError = (banner_errorType: string) => {
    try {
      const { component_type, event, banner_action } = BANNER_COMMON_EVENTS.BANNER_DISMISS;
      const trackData: TBannerError = {
        component_name: featureName,
        component_type: component_type as COMPONENT_TYPE,
        banner_action,
        country,
        language,
        eventCategory: '',
        banner_errorType,
      };
      trackByEvent<TBannerError>(event, trackData);
    } catch (error) {
      console.log('trackBannerError error', error);
    }
  };

  return { trackBannerView, trackBannerSelect, trackBannerDismiss, trackBannerError };
}
